/**
 * Merge refs without violating the rules of hooks.
 */

import mergeRefs from 'merge-refs'
import type { Ref, RefObject } from 'react'

export const useMergeRefs = <T>(...refs: (Ref<T | null> | RefObject<T | null> | null | undefined)[]) =>
  mergeRefs(...refs)
